// extracted by mini-css-extract-plugin
module.exports = {"btn_warning":"buttons_btn_warning__3_OhP"};